import { MessageCircle, Mic, Video } from 'lucide-react';
import React from 'react';

const MODES = [
  { id: 'chat', label: 'Chat', icon: MessageCircle },
  { id: 'voice', label: 'Voice', icon: Mic },
  { id: 'video', label: 'Video', icon: Video },
];

export function InteractionModeSwitcher({ value = 'chat', onChange, disabled = false }) {
  return (
    <div className="inline-flex items-center rounded-lg border border-gray-200 bg-gray-50 p-1">
      {MODES.map((mode) => {
        const Icon = mode.icon;
        const isActive = value === mode.id;

        return (
          <button
            key={mode.id}
            type="button"
            onClick={() => onChange?.(mode.id)}
            disabled={disabled}
            className={`inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50 ${
              isActive
                ? 'bg-white text-gray-950 shadow-sm'
                : 'text-gray-600 hover:bg-white hover:text-gray-900'
            }`}
          >
            <Icon className="h-4 w-4" />
            {mode.label}
          </button>
        );
      })}
    </div>
  );
}

export default InteractionModeSwitcher;
